var map = {
	"./datasets/icon-cc.svg": 95753,
	"./datasets/icon-cd.svg": 66310,
	"./datasets/icon-ce.svg": 80695,
	"./datasets/icon-chasm_wdd.svg": 34929,
	"./datasets/icon-chasm_wds.svg": 18046,
	"./datasets/icon-chasm_wvd.svg": 66539,
	"./datasets/icon-chasm_wvh.svg": 18687,
	"./datasets/icon-chasm_wvp.svg": 5543,
	"./datasets/icon-chasm_wvt.svg": 35035,
	"./datasets/icon-dd.svg": 97943,
	"./datasets/icon-el.svg": 31004,
	"./datasets/icon-gb.svg": 52340,
	"./datasets/icon-gll_dtm.svg": 40966,
	"./datasets/icon-mo_50.svg": 77497,
	"./datasets/icon-mo_90.svg": 2805,
	"./datasets/icon-ms.svg": 63267,
	"./datasets/icon-mt.svg": 93084,
	"./datasets/icon-pp.svg": 36591,
	"./datasets/icon-rp.svg": 94485,
	"./datasets/icon-sh.svg": 99762,
	"./datasets/icon-sids.svg": 52236,
	"./datasets/icon-sl.svg": 21598,
	"./datasets/icon-sm.svg": 84175,
	"./datasets/icon-ti.svg": 28242,
	"./datasets/icon-tt.svg": 45463,
	"./datasets/icon-wd.svg": 86938,
	"./datasets/icon-wl.svg": 72770,
	"./datasets/icon-wl0.svg": 55518,
	"./datasets/icon-wv.svg": 1064,
	"./datasets/icon-wwqa.svg": 57927,
	"./icon-account.svg": 70100,
	"./icon-action-chevron-down.svg": 65120,
	"./icon-action-cross.svg": 43034,
	"./icon-collapse.svg": 10354,
	"./icon-deltares.svg": 48967,
	"./icon-hkv.svg": 18330,
	"./icon-info.svg": 82519,
	"./icon-placeholder.svg": 94190,
	"./themes/icon-Coastal Management.svg": 63396,
	"./themes/icon-Flooding.svg": 28414,
	"./themes/icon-North Sea.svg": 12434,
	"./themes/icon-Offshore.svg": 52764,
	"./themes/icon-Sea level rise.svg": 47356,
	"./themes/icon-Sea level.svg": 42961,
	"./themes/icon-Small island states.svg": 8184,
	"./themes/icon-Water availability.svg": 83504,
	"./themes/icon-Water quality.svg": 45492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20283;